

// style_addNewStyle_f
export const style_addNewStyle_f = (css_s) => {
    let style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = css_s;
    document.getElementsByTagName('head')[0].appendChild(style);
}